import moment from 'moment';
import momentz from 'moment-timezone';

// Using this flag we will seperate the eventify and kochify features.
// export const DEVELOPMENT_TYPE = 'koachify';
export const DEVELOPMENT_TYPE = 'eventify';

// ========= New Prod ============ //
export const SITE_URL = 'eventify.io';
export const MAIN_URL = 'https://hub.eventify.io/'; // Prod
export const INSTANCE_URL = 'https://api3.eventify.io'; // Prod
export const FILES_URL = `${INSTANCE_URL}/api/v2/files`; // prod
export const FILES_LOCAL_URL = `${INSTANCE_URL}/api/v2/files3`; // Prod
export const VIDEO_FILES_URL = `${INSTANCE_URL}/api/v2/getvideo`; // prod
export const CHAT_MEDIA_FOLDER = 'eventify/chatmedia';
export const CHAT_MEDIA_URL = `${FILES_URL}/${CHAT_MEDIA_FOLDER}`; // prod
export const DOMAIN_NAME =
  DEVELOPMENT_TYPE === 'koachify' ? 'koachify.io' : 'eventify.io';

// Stripe
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_VZSpPMDkLza88TRanKPF0xMU'; // Live
export const STRIPE_CLIENTID = 'ca_FHZmcGRhYTWD3w1XasrY36koIRCCV7OO'; // Live
// export const STRIPE_SECRET_KEY = 'sk_live_NMvqxX3juvDu50NHnvhsTbJv'; // Live
// ========================== //

export const STOP_API_CALLS = false;
export const INSTANCE_URL_API4 = 'https://api4.eventify.io'; // Prod

// ========= Dev ============ //
// export const SITE_URL = 'dev.eventify.io';
// export const MAIN_URL = 'https://dev.eventify.io/'; // Dev
// export const INSTANCE_URL = 'https://devapi.eventify.io'; // Dev
// export const FILES_URL = `${INSTANCE_URL}/api/v2/files`; // Dev
// export const FILES_LOCAL_URL = `${INSTANCE_URL}/api/v2/files3`; // Dev
// export const VIDEO_FILES_URL = `${INSTANCE_URL}/api/v2/getvideo`; // Dev
// export const CHAT_MEDIA_FOLDER = 'eventify/chatmedia';
// export const CHAT_MEDIA_URL = `${FILES_URL}/${CHAT_MEDIA_FOLDER}`; // Dev
// export const DOMAIN_NAME =
//   DEVELOPMENT_TYPE === 'koachify' ? 'koachify.io' : 'dev.eventify.io';

// // Stripe
// export const STRIPE_PUBLISHABLE_KEY = 'pk_test_mYqHtpyz7nX68JwESQs6bMQ8'; // Test
// export const STRIPE_CLIENTID = 'ca_FHZmJN9uD8yzTD2iI25j0RgqcKvJbUYl'; // Test
// // export const STRIPE_SECRET_KEY = 'sk_test_QGxZXg6tB3T2hsxkUDV762Wi'; // Test
// ========================== //

// ========= Old Prod ============ //
// export const MAIN_URL = 'https://app.eventify.io/'; // prod
// export const INSTANCE_URL = 'https://api2.eventify.io'; // prod
// export const FILES_URL = `${INSTANCE_URL}/api/v2/files`; // prod
// export const FILES_LOCAL_URL = `${INSTANCE_URL}/api/v2/files3`; // prod
// export const CHAT_MEDIA_FOLDER = 'eventify/chatmedia';
// export const CHAT_MEDIA_URL = `${FILES_URL}/${CHAT_MEDIA_FOLDER}`; // prod

// // Stripe
// export const STRIPE_PUBLISHABLE_KEY = 'pk_live_VZSpPMDkLza88TRanKPF0xMU'; // Live
// export const STRIPE_SECRET_KEY = 'sk_live_NMvqxX3juvDu50NHnvhsTbJv'; // Live
// export const STRIPE_CLIENTID = 'ca_FHZmcGRhYTWD3w1XasrY36koIRCCV7OO'; // Live
// ========================== //

export const LOCAL_FILES_URL = 'src/assets/';
export const LOCAL_FILES_IMG = `${LOCAL_FILES_URL}img/`;

export const APP_API_KEY =
  'c26f1a65cc24c851ed1d2ebb69eb2d64686823891ca0408dae59fb58b6844293';
export const FILE_API_KEY =
  'dd2f56da7e61144400859b3efd54594fc4fb31997c34bf370892ee34eba80250';

// export const GOOGLE_MAP_KEY = 'AIzaSyCFUITnYyLeEW_nmAxZgYbMpfKQwLAlLMU'; // Test
export const GOOGLE_MAP_KEY = 'AIzaSyD43ZsO29SstAuHzztQzx_EGCY1t50SPF8'; // Test
export const GOOGLE_MAP_LOCATION_URL = 'https://www.google.com/maps/search/';
export const GOOGLE_MAP_DIRECTION_URL =
  'https://www.google.com/maps/dir/current+location/';

export const LABEL_POSITION_TOP = 'TOP';
export const LABEL_POSITION_LEFT = 'LEFT';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_FORMAT_WITH_SECOND = 'YYYY-MM-DD HH:mm:ss';
export const LOCAL_TIMEZONE = localTimezone();
export const LOCAL_TO_GMT_TIME = converLocalDateIntoGMT();

export const THUMB_20 = 'thumb20_';

export const INTERVAL_1 = 1000;
export const INTERVAL_3 = 3000;
export const INTERVAL_5 = 5000;
export const INTERVAL_10 = 10000;

export const OFFSET_LIMIT_10 = 10;
export const OFFSET_LIMIT_20 = 20;
export const OFFSET_LIMIT_50 = 50;
export const OFFSET_LIMIT_100 = 100;
export const OFFSET_LIMIT_500 = 500;
export const OFFSET_LIMIT_1000 = 1000;

function localTimezone() {
  // const tz = momentz.tz.guess();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return tz;
}

function converLocalDateIntoGMT() {
  let today = new Date();
  let str = today.toGMTString();
  let datetimeGMT = moment(str, 'ddd, DD MMM YYYY HH:mm:ss'); // Parse string in local time
  let datetime = datetimeGMT.format('YYYY-MM-DD HH:mm:ss');

  return datetime;
}

export const EVENT_DATE_CONVERTED_TOLOCAL = (date, eventtimezone) => {
  // console.log('date :- ', date);
  // console.log('eventtimezone :- ', eventtimezone);
  let now = momentz.utc(date);
  // console.log('now :- ', now);
  // get the zone offsets for this time, in minutes
  let event_tz_offset = momentz.tz.zone(eventtimezone).utcOffset(now);
  let local_tz_offset = momentz.tz.zone(localTimezone()).utcOffset(now);

  // calculate the difference in minutes
  let offset = event_tz_offset - local_tz_offset;

  // Adding difference minutes in date
  let localTime = moment(date).add(offset, 'minutes');

  // console.log('eventtimezone:- ', eventtimezone);
  // console.log('localtimezone:- ', localTimezone());
  // console.log('event_tz_offset:- ', event_tz_offset);
  // console.log('local_tz_offset:- ', local_tz_offset);
  // console.log('offset:- ', offset);
  // console.log('time:- ', localTime.format('YYYY-MM-DD HH:mm:ss'));
  return localTime;
};

export const converDateIntoLocal = date => {
  let stillUtc = moment.utc(date).toDate();
  let local = moment(stillUtc).local();
  // .format('YYYY-MM-DD HH:mm:ss');
  return local;
};

export const detectBrowser = () => {
  let browserName = navigator.appName;
  let fullVersion = '' + parseFloat(navigator.appVersion);
  let nAgt = navigator.userAgent;
  let nameOffset, verOffset;

  if ((verOffset = nAgt.indexOf('OPR/')) != -1) {
    browserName = 'Opera';
    fullVersion = nAgt.substring(verOffset + 4);
  }
  // In older Opera, the true version is after "Opera" or after "Version"
  else if ((verOffset = nAgt.indexOf('Opera')) != -1) {
    browserName = 'Opera';
    fullVersion = nAgt.substring(verOffset + 6);
    if ((verOffset = nAgt.indexOf('Version')) != -1)
      fullVersion = nAgt.substring(verOffset + 8);
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
    browserName = 'Microsoft Internet Explorer';
    fullVersion = nAgt.substring(verOffset + 5);
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
    browserName = 'Chrome';
    fullVersion = nAgt.substring(verOffset + 7);
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
    browserName = 'Safari';
    fullVersion = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf('Version')) != -1)
      fullVersion = nAgt.substring(verOffset + 8);
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
    browserName = 'Firefox';
    fullVersion = nAgt.substring(verOffset + 8);
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if (
    (nameOffset = nAgt.lastIndexOf(' ') + 1) <
    (verOffset = nAgt.lastIndexOf('/'))
  ) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
    if (browserName.toLowerCase() == browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }
  let returnData = {};
  returnData.browserName = browserName;
  returnData.fullVersion = fullVersion;
  return returnData;
};

export const nl2br = (str, is_xhtml) => {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  let breakTag =
    is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  );
};
